import React, { Component } from 'react'
import { Button, Input, Select } from '@mobiscroll/react-latest'
import { IPaymentSourceResponseDTO, IRiderObject } from '../../../../types'
import UIMessages from 'src/utils/ui-messages'
import { withPaymentSource } from './PaymentSourceHOC'
import { PaymentSourceContextType } from './PaymentSourceContext'
import { isEqual } from 'lodash'

interface IDirectChargeProps extends PaymentSourceContextType {
  rider: IRiderObject
  history: any
  match: any
}

interface IDirectChargeState {
  selected: string
}

const formatCardDetails = (pmethod: IPaymentSourceResponseDTO): string => {
  return `${pmethod.last4}- EXP ${pmethod.exp_month}/${pmethod.exp_year}`
}

class DirectChargePanel extends Component<IDirectChargeProps, IDirectChargeState> {
  constructor(props: IDirectChargeProps) {
    super(props)
    this.state = {
      selected: ''
    }
  }

  public componentDidUpdate(
    prevProps: Readonly<IDirectChargeProps>,
    prevState: Readonly<IDirectChargeState>,
    snapshot?: any
  ): void {
    if (!isEqual(this.props.rider, prevProps.rider) || prevState.selected !== this.state.selected) {
      const selectedPMethod = this.props.rider.wallet.sources.find(pm => pm.id === this.state.selected)
      if (selectedPMethod) {
        this.props.setPaymentSource({
          label: formatCardDetails(selectedPMethod),
          value: selectedPMethod.id
        })
      }
    }
  }

  public render() {
    return (
      <>
        <div className='mt1 border-top'>
          <div className='mb2 mt2'>
            <Select
              name='SelectPaymentMethod'
              value={this.getPaymentMethodValue(this.state.selected)}
              onChange={this.onPaymentMethodChange}
              data={this.getPaymentMethods()}
              touchUi={false}
              theme='ios'
              themeVariant='light'
              inputStyle='box'
              label={UIMessages.common.paymentMethod}
              labelStyle='floating'
            />
          </div>
          <div className='font-red ml1 h5'>
            <small>Processing fee of 3% will be added to the trip cost.</small>
          </div>
        </div>
        <div className='flex items-center justify-between mt3'>
          <Button
            type='button'
            ariaLabel='addPaymentMethod'
            onClick={this.handleAddPaymentMethod}
            className='mbsc-clear-btn borderless mr-auto'
          >
            + {UIMessages.common.addPaymentMethod}
          </Button>
        </div>
      </>
    )
  }

  private getPaymentMethods() {
    const pmethods: Array<{ text: string; value: string }> = []

    if (this.props.rider && this.props.rider.wallet) {
      for (const idx of Object.keys(this.props.rider.wallet.sources)) {
        const pmethod: IPaymentSourceResponseDTO = this.props.rider.wallet.sources[idx]
        pmethods.push({
          text: formatCardDetails(pmethod),
          value: pmethod.id
        })
      }
    }

    return pmethods.length === 0 ? [{ text: 'No Options', value: 'No Options', disabled: true }] : pmethods
  }

  private getPaymentMethodValue(selectedValue: string): string {
    const selectedPMethod = this.getPaymentMethods().find(pm => pm.value === selectedValue)

    if (selectedPMethod !== undefined) {
      return selectedPMethod.text
    } else {
      return ''
    }
  }

  private onPaymentMethodChange = (event: any) => {
    if (event.value !== null) {
      this.setState({
        selected: event.value
      })
    }
  }

  private handleAddPaymentMethod = () => {
    this.props.history.push(this.props.match.url + '/add-card')
  }
}

export default withPaymentSource(DirectChargePanel)



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/payments/DirectChargePanel.tsx